import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  AnalyticsTileCard,
  TileIconBox,
  TileContent,
  TileTitle,
  TileValue,
  TileSubtitle,
  TrendBadge,
  ProgressContainer,
  ProgressLabel,
  TileContainer,
  TileHeader,
  TrendIconWrapper,
  StyledProgress,
  TileValueSkeleton,
  ProgressPercentageSkeleton,
  ProgressBarSkeleton,
} from "./styles";
import { AnalyticsTileProps, TREND_CONFIG } from "./Constant";

const AnalyticsTile: React.FC<AnalyticsTileProps> = ({
  title,
  icon,
  value,
  trend,
  trendValue,
  color,
  onClick,
  subtitle,
  progress,
  accentColor,
  loading = false,
}) => {
  const trendConfig = trend ? TREND_CONFIG[trend] : null;

  return (
    <AnalyticsTileCard onClick={onClick} accentColor={accentColor || color}>
      <TileContainer>
        <TileHeader>
          <TileIconBox bg={`${color}20`} color={color}>
            <FontAwesomeIcon icon={icon} size="lg" />
          </TileIconBox>
          {trendConfig && trendValue !== undefined && !loading && (
            <TrendBadge color={trendConfig.color}>
              <TrendIconWrapper>
                <FontAwesomeIcon icon={trendConfig.icon} size="xs" />
              </TrendIconWrapper>
              {Math.floor(trendValue)}%
            </TrendBadge>
          )}
        </TileHeader>

        <TileContent>
          <TileTitle>{title}</TileTitle>
          {loading ? (
            <TileValueSkeleton active size="large" />
          ) : (
            <TileValue>{typeof value === 'string' ? value : value.toLocaleString()}</TileValue>
          )}
          <TileSubtitle>{subtitle || ""}</TileSubtitle>
        </TileContent>

        <ProgressContainer>
          <ProgressLabel>
            <span>Progress</span>
            {loading ? (
              <ProgressPercentageSkeleton active size="small" />
            ) : (
              <span>{progress || 0}%</span>
            )}
          </ProgressLabel>
          {loading ? (
            <ProgressBarSkeleton active />
          ) : (
            <StyledProgress
              percent={progress || 0}
              strokeColor={accentColor || color}
              showInfo={false}
            />
          )}
        </ProgressContainer>
      </TileContainer>
    </AnalyticsTileCard>
  );
};

export default AnalyticsTile;